import { env } from '../env.ts';

export const STAFF_PORTAL_URL = env.VITE_STAFF_PORTAL_URL
	? env.VITE_STAFF_PORTAL_URL
	: 'https://quotes.parts-badger.com';

interface Status {
	label: string;
	field_name: string;
	statuses: string[];
}

export const statuses: Status[] = [
	{
		label: 'Ballooning',
		field_name: 'ballooning_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Keyence Programming',
		field_name: 'keyence_programming_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Programming Template',
		field_name: 'programming_template_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Tooling Selection',
		field_name: 'tooling_selection_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Material Selection',
		field_name: 'material_selection_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Material Ordering',
		field_name: 'material_ordering_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'PB Prod Accepted',
		field_name: 'pb_prod_accepted_status',
		statuses: ['Not Started', 'Yes', 'No'],
	},
	{
		label: 'CAM Programming',
		field_name: 'cam_programming_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},

	{
		label: 'Tooling Ordering',
		field_name: 'tooling_ordering_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Material Prep',
		field_name: 'material_prep_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Kitting',
		field_name: 'cart_assembly_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Machine Setup',
		field_name: 'machine_setup_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
	{
		label: 'Machining',
		field_name: 'machining_status',
		statuses: ['Not Started', 'In Progress', 'Completed'],
	},
    {
        label: 'Quality Status',
        field_name: 'quality_status',
        statuses: ['Not Started', 'In Progress', 'Completed'],
    },
    // Delivery progress for finished parts
    {
        label: 'Delivered',
        field_name: 'delivery_status',
        statuses: ['Not Started', 'Partial Delivery', 'Delivered in Full'],
    },
];

interface Tab {
	label:
		| 'Ballooning'
		| 'Keyence Programming'
		| 'Programming Template'
		| 'Material Selection'
		| 'Material Ordering'
		| 'PB Prod Accepted'
		| 'Material Prep'
		| 'Tooling Selection'
		| 'Tooling Ordering'
		| 'CAM Programming'
		| 'Kitting'
		| 'Machine Setup'
		| 'Machining';
	field_name:
		| 'ballooning_status'
		| 'keyence_programming_status'
		| 'programming_template_status'
		| 'material_selection_status'
		| 'material_ordering_status'
		| 'pb_prod_accepted_status'
		| 'material_prep_status'
		| 'tooling_selection_status'
		| 'tooling_ordering_status'
		| 'cam_programming_status'
		| 'cart_assembly_status'
		| 'machine_setup_status'
		| 'machining_status';
}

export const productionQueueTabs: Tab[] = [
	{
		label: 'Ballooning',
		field_name: 'ballooning_status',
	},
	{
		label: 'Keyence Programming',
		field_name: 'keyence_programming_status',
	},
	{
		label: 'Programming Template',
		field_name: 'programming_template_status',
	},
	{
		label: 'Tooling Selection',
		field_name: 'tooling_selection_status',
	},
	{
		label: 'Material Selection',
		field_name: 'material_selection_status',
	},
	{
		label: 'Material Ordering',
		field_name: 'material_ordering_status',
	},
	{
		label: 'PB Prod Accepted',
		field_name: 'pb_prod_accepted_status',
	},
	{
		label: 'CAM Programming',
		field_name: 'cam_programming_status',
	},
	{
		label: 'Tooling Ordering',
		field_name: 'tooling_ordering_status',
	},
	{
		label: 'Material Prep',
		field_name: 'material_prep_status',
	},
	{
		label: 'Kitting',
		field_name: 'cart_assembly_status',
	},
	{
		label: 'Machine Setup',
		field_name: 'machine_setup_status',
	},
	{
		label: 'Machining',
		field_name: 'machining_status',
	},
];

export const INTERNAL_CATEGORIES = [
	{ value: 'tooling', label: 'Tooling' },
	{ value: 'fixture', label: 'Fixture' },
	{ value: 'rd', label: 'R&D / Prototyping' },
	{ value: 'rework', label: 'Rework' },
	{ value: 'maintenance', label: 'Maintenance' },
	{ value: 'training', label: 'Training / Qualification' },
	{ value: 'other', label: 'Other' },
];

export const RECTANGLE_BAR = 'Rectangle Bar';
export const EXTRUSION = 'Extrusion';
export const ROUND_BAR = 'Round Bar';
export const HEX_BAR = 'Hex Bar';
export const PLATE = 'Plate';
export const RECTANGLE_TUBE = 'Rectangle Tube';
export const ROUND_TUBE = 'Round Tube';
export const ANGLE = 'Angle';
export const CHANNEL = 'Channel';

export const MATERIAL_STATUSES = [
	'Awaiting Delivery',
	'In Stock',
	'Quality Hold',
	'Scrapped',
];

export const queueOverviewData = [
	{
		name: 'Ballooning',
		field: 'ballooning_count',
		url: '/production/queues?queue=ballooning_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Keyence',
		field: 'keyence_count',
		url: '/production/queues?queue=keyence_programming_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Programming Template',
		field: 'programming_template_count',
		url: '/production/queues?queue=cam_programming_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Tooling Selection',
		field: 'tooling_selection_count',
		url: '/production/queues?queue=tooling_selection_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Tooling Ordering',
		field: 'tooling_ordering_count',
		url: '/production/queues?queue=tooling_ordering_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Kitting',
		field: 'cart_assembly_count',
		url: '/production/queues?queue=cart_assembly_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Material Ordering',
		field: 'material_ordering_count',
		url: '/production/queues?queue=material_ordering_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'CAM Programming',
		field: 'cam_programming_count',
		url: '/production/queues?queue=cam_programming_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Material Cutting',
		field: 'material_prep_count',
		url: '/production/queues?queue=material_prep_status&page=1&ordering=scheduling_start_date',
	},
	{
		name: 'Material Receiving',
		field: 'material_receiving_count',
		url: '/tablet/operations/receiving',
	},
	{
		name: 'Material Delivery',
		field: 'material_delivery_count',
		url: 'tablet/operations/delivery?delivery_status=Pending',
	},
];
